import React from 'react'
import arrowIcon from 'assets/img/icon-arrow.png'

export default function WhyWorkWithUs(){
  return(
    <section className="py-20">
      <div className="container">
        <div className="max-w-2xl mx-auto text-center">
          <img
            src={arrowIcon}
            width="100"
            className="m-auto mb-2"
            alt="Arrow Icon"
          />
          <h2 className="text-5xl font-platform text-navy leading-none mb-6 text-center">
            Booking Marketplace
          </h2>
          <p className="text-gray-900 mb-4 font-light text-lg leading-6 font-national">
            Fill your calendar with new opportunities- private catering, corporate catering, big events, weddings, vending & more.
          </p>
          <ul className="text-gray-900 list-outside list-disc pl-10 font-light text-lg leading-6 text-left">
            <li>Get hired for paid catering opportunities</li>
            <li>Book local community events</li>
            <li>Get selected for vending opportunities, festivals and conventions, and exclusive Roaming Hunger partnerships</li>
          </ul>
        </div>
        <hr className="w-full h-px text-gray-900 border-top border-solid my-20" />
      </div>
    </section>
  )
}
